import type { ProfileDto } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/types/dto";
import type IRoleChangesSignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/role-changes/RoleChangesSignalFilters";
import type RoleChangeType from "app/pages/sales-intelligence/sub-modules/signals/models/role-changes/RoleChangeType";
import { getValidEmployeeProfileIds } from "app/pages/sales-intelligence/sub-modules/signals/utils/role-changes/getValidEmployeeProfileIds";
import { isKnownRoleChangeType } from "app/pages/sales-intelligence/sub-modules/signals/utils/role-changes/roleChangeTypeI18n";

/** While profiles are still loading, keep stored ids; validate once options are available. */
export const reconcileEmployeeProfileIdsWithProfiles = (
    employeeProfileIds: readonly string[] | undefined,
    profiles: readonly ProfileDto[],
): readonly string[] => {
    if (profiles.length === 0) {
        return employeeProfileIds ?? [];
    }

    // An empty list is the "any persona" value the back end expects — never expand it to every id.
    return getValidEmployeeProfileIds(employeeProfileIds, profiles);
};

type InitialiseFiltersStateParams = {
    filters: Partial<IRoleChangesSignalFilters>;
    changeTypeOptions: readonly RoleChangeType[];
    profiles: readonly ProfileDto[];
};

export const initialiseFiltersState = ({
    filters,
    changeTypeOptions,
    profiles,
}: InitialiseFiltersStateParams): (() => IRoleChangesSignalFilters) => {
    return () => {
        const changeTypes = (filters.changeTypes ?? []).filter(
            (changeType): changeType is RoleChangeType =>
                isKnownRoleChangeType(changeType) && changeTypeOptions.includes(changeType),
        );
        const employeeProfileIds = reconcileEmployeeProfileIdsWithProfiles(filters.employeeProfileIds, profiles);

        return {
            changeTypes,
            employeeProfileIds,
        };
    };
};
